import "./App.css";
import Dashboard from "./pages/system/Dashboard";

const App = ({ title }) => {


  return (

    <Dashboard title='Dashboard' />


  );
};

export default App;
